import { useCallback, useEffect, useState } from "react";
import okrPlansCoachStore, {
  useOkrPlansCoachStore,
} from "../_store/okrPlansCoachStore";

// useCoachPlan(planId) — the plan detail (BE 2.7) every plan-level coach
// screen needs. Cache first, one fetch per plan id, `reload` on demand.
const useCoachPlan = (planId) => {
  const selectPlan = useCallback((s) => s.plans[planId], [planId]);
  const plan = useOkrPlansCoachStore(selectPlan);
  const [error, setError] = useState(null);
  const reload = useCallback(() => {
    setError(null);
    return okrPlansCoachStore
      .getState()
      .fetchPlan(planId)
      .catch((err) => setError(err));
  }, [planId]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { plan, error, reload };
};

export default useCoachPlan;
